import React from 'react'

import { Button, Typography } from '@telavita-core/react-design-kit'

import ModalGeneric from 'containers/ModalManager/Modals/ModalGeneric'

import * as S from './styles'

export interface TranscriptionAuthorizerDisclaimerModalProps {
  firstName: string
  onAccept: () => void
  onClose: () => void
}

export const TranscriptionAuthorizerDisclaimerModal: React.FC<TranscriptionAuthorizerDisclaimerModalProps> = ({
  firstName,
  onAccept,
  onClose,
}) => {
  return (
    <ModalGeneric
      modalTitle=''
      hasCloseButton
      onCloseModal={onClose}
    >
      <S.TranscriptionAuthorizerDisclaimerModalContainer>
        <Typography variant='content1' weight='bolder'>
          Entendemos e respeitamos sua decisão de não permitir a gravação do áudio da consulta, {firstName}.
        </Typography>

        <div>
          <Typography variant='content2' weight='normal'>
            No entanto, é importante informar que, sem essa autorização, <b>o prontuário será preenchido de forma mais limitada</b>, baseado apenas nas anotações feitas durante ou após a sessão. Isso pode fazer com que <b>detalhes importantes da conversa se percam</b>, o que afeta a qualidade e a profundidade do registro clínico.
          </Typography>

          <Typography variant='content2' weight='normal'>
            Além disso, <b>o psicólogo pode precisar dedicar mais tempo para escrever o prontuário manualmente</b>, o que reduz o tempo disponível para focar exclusivamente no seu acompanhamento e planejamento terapêutico.
          </Typography>

          <Typography variant='content2' weight='normal'>
            A gravação temporária, quando permitida, traz um ganho significativo na <b>eficiência do tratamento e na precisão das informações registradas</b> — sempre com segurança, confidencialidade e descarte automático após a transcrição. Estamos à disposição para esclarecer qualquer dúvida.
          </Typography>
        </div>

        <S.ButtonsWrapper>
          <Button
            onClick={onClose}
            uppercase={false}
            variant='outlined'
            id='decline-transcription-button'
          >
            Fechar
          </Button>

          <Button
            onClick={onAccept}
            uppercase={false}
            variant='contained'
            color='success'
            id='accept-transcription-button'
          >
            Mudei de ideia, quero permitir
          </Button>
        </S.ButtonsWrapper>
      </S.TranscriptionAuthorizerDisclaimerModalContainer>
    </ModalGeneric>
  )
}